var metric, imperial;

metric = {
  mm: {
    to_anchor: 1/1000
  },
  cm: {
    to_anchor: 1/100
  },
  m: {
    to_anchor: 1
  },
  km: {
    to_anchor: 1000
  }
};

imperial = {
  'in': {
    to_anchor: 1/12
  },
  yd: {
    to_anchor: 3
  },
  'ft-us': {
    to_anchor: 1.000002
  },
  ft: {
    to_anchor: 1
  },
  mi: {
    to_anchor: 5280
  }
};

module.exports = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: 'm',
      ratio: 3.28084
    },
    imperial: {
      unit: 'ft',
      ratio: 1/3.28084
    }
  }
};
